import {
  Box,
  Button,
  Chip,
  InputAdornment,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import FilterMultiSelect from "../../components/FilterMultiSelect";
import { tokens } from "../../theme";
import styles from "./styles";

// Shared filter row for both PR tabs: title search + multi-select filters,
// a "{filtered} of {total}" count on the right, and an applied-filters chip
// row below (same pattern as the Vulnerabilities page).
const PrFilterBar = ({
  filters,
  selected,
  onChange,
  onClearAll,
  search,
  onSearchChange,
  filteredCount,
  totalCount,
  itemsNoun = "PRs",
  searchPlaceholder = "Search PR title…",
}) => {
  const theme = useTheme();
  const colors = tokens(theme.paletteId);
  const hasActiveFilters = Object.values(selected).some(
    (values) => values?.length
  );

  return (
    <>
      <Box sx={styles.filterStack}>
        <TextField
          size="small"
          placeholder={searchPlaceholder}
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          sx={styles.searchField}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
        {filters.map(({ name, label, options }) => (
          <FilterMultiSelect
            key={name}
            label={label}
            options={options}
            selected={selected[name] || []}
            onChange={(values) => onChange(name, values)}
            sx={styles.filterButton(name)}
          />
        ))}
        <Typography sx={styles.countText}>
          {totalCount != null
            ? `${filteredCount} of ${totalCount} ${itemsNoun}`
            : ""}
        </Typography>
      </Box>
      {hasActiveFilters ? (
        <Box sx={styles.appliedFiltersRow}>
          <Typography sx={styles.appliedFiltersLabel}>FILTERING BY</Typography>
          {filters.flatMap(({ name }) =>
            (selected[name] || []).map((value) => (
              <Chip
                key={`${name}-${value}`}
                label={value}
                size="small"
                sx={styles.appliedFilterChip(colors)}
                onDelete={() =>
                  onChange(
                    name,
                    selected[name].filter((item) => item !== value)
                  )
                }
              />
            ))
          )}
          <Button sx={styles.clearAllButton} onClick={onClearAll}>
            Clear all
          </Button>
        </Box>
      ) : null}
    </>
  );
};

export default PrFilterBar;
